import React from 'react';
import { Select, SelectItem } from '@heroui/react';

interface FileTypeDropdownProps {
	value: string;
	onChange: (value: string) => void;
}

const FileTypeDropdown: React.FC<FileTypeDropdownProps> = ({ value, onChange }) => {
	const fileTypes = [
		{ key: 'csv', label: 'CSV' },
		{ key: 'xlsx', label: 'Excel' },
		{ key: 'parquet', label: 'Parquet' },
	];

	// Default to parquet if no value is provided
	const selectedValue = value;

	return (
		<div className="flex flex-row w-full items-center">
			<span className="mb-1 text-sm font-medium w-1/3 text-msi-midblue-color-500">File Type:</span>
			<Select
				placeholder="Select file type"
				selectedKeys={[selectedValue]}
				onSelectionChange={(keys) => {
					const selectedKey = Array.from(keys)[0] as string;
					onChange(selectedKey);
				}}
				className="w-2/3"
				size="sm"
				isRequired
				aria-label='Select File Type'
			>
				{fileTypes.map((fileType) => (
					<SelectItem key={fileType.key}>{fileType.label}</SelectItem>
				))}
			</Select>
		</div>
	);
};

export default FileTypeDropdown;
